import { Component } from '@angular/core';
import { 
  TypographyColor, 
  TypographyFontFamily, 
  TypographyFontSize 
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-billing-section-header',
  templateUrl: './billing-section-header.component.html',
  styleUrls: ['./billing-section-header.component.sass'],
  standalone: false
})
export class BillingSectionHeaderComponent {

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  constructor() { }
}
